module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-six2.93b3a7a6.png";